export class SubscriptionPayment {
  id: number;

  date: string;

  status: string;

  payment_id: string;
}



// WEBPACK FOOTER //
// /app/src/app/entities/subscription-payment.entity.ts